"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BatchPriceDialog',
  props: {
    productIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    merId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      calcLoading: false,
      submitLoading: false,
      form: {
        debtRatio: null,
        markupParam: null
      },
      tierList: [],
      calcItems: [],
      errorCount: 0
    };
  },
  computed: {
    canSubmit: function canSubmit() {
      return this.calcItems.length > 0 && this.calcItems.some(function (item) {
        return !item.isError;
      });
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.loadTiers();
      }
    }
  },
  methods: {
    loadTiers: function () {
      var _loadTiers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.merId) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.loading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _product.debtRatioTiersApi)(this.merId);
            case 3:
              res = _context.v;
              this.tierList = res;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.$message.error(_t.message || '加载债权档位失败');
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadTiers() {
        return _loadTiers.apply(this, arguments);
      }
      return loadTiers;
    }(),
    onDebtRatioChange: function () {
      var _onDebtRatioChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(debtRatio) {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!debtRatio || !this.merId)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return (0, _product.debtRatioMarkupApi)({
                merId: this.merId,
                debtRatio: debtRatio
              });
            case 2:
              res = _context2.v;
              this.form.markupParam = res;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.$message.error(_t2.message || '加载上浮参数失败');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function onDebtRatioChange(_x) {
        return _onDebtRatioChange.apply(this, arguments);
      }
      return onDebtRatioChange;
    }(),
    handleCalc: function () {
      var _handleCalc = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.form.debtRatio) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('请选择债权额档位');
              return _context3.a(2);
            case 1:
              if (!(this.form.markupParam === null || this.form.markupParam === undefined)) {
                _context3.n = 2;
                break;
              }
              this.$message.warning('请设置上浮参数');
              return _context3.a(2);
            case 2:
              this.calcLoading = true;
              _context3.p = 3;
              _context3.n = 4;
              return (0, _product.batchPriceCalcApi)({
                productIds: this.productIds,
                debtRatio: this.form.debtRatio,
                markupParam: this.form.markupParam
              });
            case 4:
              res = _context3.v;
              this.calcItems = res.calcItems || [];
              this.errorCount = res.errorCount || 0;
              if (this.calcItems.length === 0) {
                this.$message.warning('没有可计算的商品');
              }
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              this.$message.error(_t3.message || '预计算失败');
            case 6:
              _context3.p = 6;
              this.calcLoading = false;
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[3, 5, 6, 7]]);
      }));
      function handleCalc() {
        return _handleCalc.apply(this, arguments);
      }
      return handleCalc;
    }(),
    handleSubmit: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this = this;
        var validItems;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              validItems = this.calcItems.filter(function (item) {
                return !item.isError;
              });
              if (!(validItems.length === 0)) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('没有可提交的正常商品');
              return _context5.a(2);
            case 1:
              this.$modalSure("\u786E\u8BA4\u5BF9 ".concat(validItems.length, " \u4E2A\u5546\u54C1\u6267\u884C\u6279\u91CF\u6539\u4EF7\u5417\uFF1F")).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var priceItems, _t4;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      _this.submitLoading = true;
                      _context4.p = 1;
                      priceItems = validItems.map(function (item) {
                        return {
                          productId: item.productId,
                          newPrice: item.calcPrice,
                          oldPrice: item.oldPrice,
                          costPrice: item.costPrice
                        };
                      });
                      _context4.n = 2;
                      return (0, _product.batchPriceUpdateApi)({
                        priceItems: priceItems,
                        debtRatio: _this.form.debtRatio,
                        markupParam: _this.form.markupParam
                      });
                    case 2:
                      _this.$message.success('批量改价成功');
                      _this.dialogVisible = false;
                      _this.$emit('success');
                      _context4.n = 4;
                      break;
                    case 3:
                      _context4.p = 3;
                      _t4 = _context4.v;
                      _this.$message.error(_t4.message || '批量改价失败');
                    case 4:
                      _context4.p = 4;
                      _this.submitLoading = false;
                      return _context4.f(4);
                    case 5:
                      return _context4.a(2);
                  }
                }, _callee4, null, [[1, 3, 4, 5]]);
              }))).catch(function () {});
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.form.debtRatio = null;
      this.form.markupParam = null;
      this.calcItems = [];
      this.errorCount = 0;
    }
  }
};